import { DataTable, MainButton, PageWrapper } from '@repo/ui';
import { useEffect, useMemo } from 'react';
import { Card, CardBody } from 'reactstrap';

import { makeSectorsListColumns } from '../../common/columns/make-sectors-list-columns';
import { DropdownSectorsStatus } from '../../components/dropdown-sectors-status';
import { ModalSectorsForm } from '../../components/modals/modal-sectors-form';
import { useSectorsList } from '../../hooks/use-sectors-list';

export const SectorsList = () => {
  const noDataConfig = {
    noDataTitle: 'Nenhum setor encontrado',
    noDataDescription: 'Não há setores cadastrados no momento.',
  };

  const {
    formik,
    resetForm,
    courses,
    sector,
    sectors,
    createSector,
    updateSector,
    deleteSector,
    isModalFormOpen,
    toggleModalForm,
    handlePageChange,
    handleSearchRemote,
    handleStatusChange,
    paginationMetadata,
    handleRowsPerPageChange,
    debouncedRequestGetSectors,
    modalMode,
  } = useSectorsList();

  const columns = useMemo(() => makeSectorsListColumns(), []);
  const isLoadingSubmit = createSector.loading || updateSector.loading;

  const handleCreate = () => {
    modalMode.set('create');
    toggleModalForm();
  };

  const handleEdit = (id: string) => {
    modalMode.set('edit');
    sector.request({ id });
    toggleModalForm();
  };

  useEffect(() => {
    const params = {
      page: paginationMetadata.selectedPage,
      length: paginationMetadata.rowsPerPage,
      status: paginationMetadata.status,
      query: paginationMetadata.searchString,
    };

    debouncedRequestGetSectors(params);
  }, [paginationMetadata, debouncedRequestGetSectors]);

  useEffect(() => {
    courses.request();
  }, []);

  return (
    <PageWrapper title="Setores">
      <ModalSectorsForm
        isEdit={modalMode.state === 'edit'}
        isOpen={isModalFormOpen}
        formik={formik}
        courses={{ ...courses }}
        toggleModal={toggleModalForm}
        isLoadingGetById={sector.loading}
        isLoadingSubmit={isLoadingSubmit}
        resetForm={resetForm}
      />

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Setores</h4>
          <p className="text-muted mb-0">
            Cadastre e gerencie os setores disponíveis.
          </p>
        </div>

        <MainButton onClick={handleCreate}>
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Novo Setor
        </MainButton>
      </div>

      <Card>
        <CardBody className="pt-0">
          <div
            className="d-flex justify-content-end align-items-center"
            style={{ height: 0, position: 'relative', zIndex: 2 }}
          >
            <div style={{ position: 'absolute', right: 0, top: 15 }}>
              <DropdownSectorsStatus
                paginationStatus={paginationMetadata.status}
                handleStatusChange={handleStatusChange}
                disabled={sectors.loading}
              />
            </div>
          </div>

          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            actions={[
              {
                id: 1,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => {
                  handleEdit(cellProps.id);
                },
                classNameColorIcon: 'primary',
                nameFeatherIcon: 'edit',
              },
            ]}
            canSearch
            searchServer
            onSearch={handleSearchRemote}
            columns={columns}
            data={sectors.data?.data || []}
            loading={sectors.loading}
            pagination
            handleDelete={(id) => deleteSector.request({ id })}
            paginationServer
            paginationTotalRows={sectors.data?.total}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            // Local (orderColumn and orderDirection)
            defaultSortAsc={true}
            defaultSortFieldId={1}
          />
        </CardBody>
      </Card>
    </PageWrapper>
  );
};
